// CNPJ numérico e alfanumérico (Receita Federal, a partir de julho de 2026):
// 12 posições alfanuméricas + 2 dígitos verificadores numéricos; cada caractere vale (código ASCII − 48).

const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, ...PESOS_DV1];

export const normalizarCnpj = (cnpj: string) => cnpj.toUpperCase().replace(/[^0-9A-Z]/g, '');

function digitoVerificador(base: string, pesos: number[]) {
  const soma = [...base].reduce((total, caractere, i) => total + (caractere.charCodeAt(0) - 48) * pesos[i]!, 0);
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function validarCnpj(cnpj: string) {
  const valor = normalizarCnpj(cnpj);
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(valor) || /^(.)\1+$/.test(valor)) return false;
  const dv1 = digitoVerificador(valor.slice(0, 12), PESOS_DV1);
  const dv2 = digitoVerificador(valor.slice(0, 12) + dv1, PESOS_DV2);
  return valor.slice(12) === `${dv1}${dv2}`;
}

export function formatarCnpj(cnpj: string) {
  return normalizarCnpj(cnpj).replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5');
}

/** CPF (representante legal): 11 dígitos com os dois verificadores. */
export function validarCpf(cpf: string) {
  const v = cpf.replace(/\D/g, '');
  if (!/^\d{11}$/.test(v) || /^(\d)\1+$/.test(v)) return false;
  const dv = (n: number) => {
    const soma = [...v.slice(0, n)].reduce((t, d, i) => t + Number(d) * (n + 1 - i), 0);
    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };
  return dv(9) === Number(v[9]) && dv(10) === Number(v[10]);
}

export type SituacaoValidade = 'valido' | 'vencendo' | 'vencido' | 'sem-validade';

/** Validade de documento da empresa (datas aaaa-mm-dd): vence hoje ou dentro do aviso é "vencendo". */
export function situacaoValidade(validoAte: string | null, hoje: string, diasAviso: number): SituacaoValidade {
  if (!validoAte) return 'sem-validade';
  if (validoAte < hoje) return 'vencido';
  const limite = new Date(`${hoje}T00:00:00Z`);
  limite.setUTCDate(limite.getUTCDate() + diasAviso);
  return validoAte <= limite.toISOString().slice(0, 10) ? 'vencendo' : 'valido';
}
